import { Injectable } from "@angular/core";
import { RequestDetailsStore } from "../../store/request-details";
import { map, Observable, of } from "rxjs";
import { MCFormisForm, MCGeneratorFieldsService, MCResponse, MC_RESPONSE_STATUS_CODE, MCSectionSchema, MCUnionRequestHttpWrapperService } from "@maslul/common-services";
import { FieldsMapperService } from "../../fields/mapper";
import cloneDeep from 'clone-deep';
import { FormlyFieldConfig } from "@ngx-formly/core";
import { RequestApprovalTypeDetailsStore } from "../../store/approval-type-details-store";

@Injectable({ providedIn: 'root' })
export class RequestDetailsService {

    constructor(
        private requestDetailsStore: RequestDetailsStore,
        private generatorFieldsService: MCGeneratorFieldsService<MCUnionRequestHttpWrapperService<any>>,
        private fieldsMapperService: FieldsMapperService,
        private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore

    ) {

    }


    getFields(formisForm: MCFormisForm): Observable<Array<FormlyFieldConfig> | undefined> {
        const approvalTypeId = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId;

        try {
            // 1. חילוץ הסכימות הגולמיות מהסטור
            const snapshot = this.requestDetailsStore.getSnapshot();
            const storedSchemas = snapshot.fieldsSchema;

            if (storedSchemas && Array.isArray(storedSchemas) && storedSchemas.length > 0) {
                console.log('Generating fresh fields from stored schemas...');

                // יצירת שדות חדשים. 
                // חשוב: לא לבצע cloneDeep על התוצאה של generateSchema!
                const freshFields = this.fieldsMapperService.generateSchema(storedSchemas, formisForm);

                return of(freshFields);
            }
            else {
                return this.generatorFieldsService.getRequestDetailsFields([parseInt(approvalTypeId)])
                    .pipe(map((res: MCResponse) => {
                        if (res && res.code === MC_RESPONSE_STATUS_CODE.SUCCESS) {
                            const schemas: Array<MCSectionSchema> = res.data as Array<MCSectionSchema>;
                            const generatedSchema: Array<FormlyFieldConfig> = this.fieldsMapperService.generateSchema(schemas, formisForm);
                            this.requestDetailsStore.setFieldsSchema(cloneDeep(schemas));
                            this.requestDetailsStore.setFormisFormFields(cloneDeep(generatedSchema));
                            return generatedSchema;
                        }
                        else {
                            throw new Error(res.data)

                        }
                    }));
            }
        }
        catch (ex) {
            console.error('getRequestDetailsFields', ex);
            return of(undefined)
        }
    }


}